import "react-toastify/dist/ReactToastify.css";
import "ag-grid-community/dist/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useState, useEffect, useMemo } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "./Components/MDSideNav";
import Configurator from "./Components/Configurator";
import themeRTL from "./Asset/theme/theme-rtl";
import themeDarkRTL from "./Asset/theme-dark/theme-rtl";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider, EmotionCache } from "@emotion/react";
import createCache from "@emotion/cache";
import routes, { IRoutes } from "./routes";
import { useMaterialUIController, setMiniSidenav } from "./Context/mui";
import brandWhite from "./Asset/images/logo-ct.png";
import brandDark from "./Asset/images/logo-ct-dark.png";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./utils/middlewares/AuthMiddleware";

function App() {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, direction, layout, sidenavColor, transparentSidenav, whiteSidenav, darkMode } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState<EmotionCache | null>(null);
  const { pathname } = useLocation();
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);
  // Open sidenav when mouse enter on mini sidenav

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };
  // Close sidenav when mouse leave mini sidenav

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };
  // Change the openConfigurator state

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);
  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    if (document !== null) {
      document.documentElement.scrollTop = 0;
      if (document.scrollingElement) {
        document.scrollingElement.scrollTop = 0;
      }
    }
  }, [pathname]);
  const getRoutes: any = (allRoutes: IRoutes[]) =>
    allRoutes.map((route: IRoutes) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.childs) {
        return getRoutes(route.childs);
      }
      if (route.route) {
        return (
          <Route
            path={route.route}
            element={
              <AuthProvider routeName={route.route} level={route.level}>
                {route.component}
              </AuthProvider>
            }
            key={route.key}
          />
        );
      }

      return null;
    });

  if (!rtlCache) return null;
  return (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />

        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName="داشبورد "
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/notfound" />} />
        </Routes>
      </ThemeProvider>
      <ToastContainer rtl />
    </CacheProvider>
  );
}

export default App;
